import React from 'react';
import { CodeBlock } from 'react-code-block';
import { useCopyToClipboard } from 'react-use';
import '@fortawesome/fontawesome-svg-core/styles.css';
import YouTube from "react-youtube";

function LegoL31Component({ code, language }) {
    code = `{/* L31 Video Box Large */}
                                    <div className="lego l031 legoMargin2">
                                        <div className="videoContainer">
                                            <div className="embedContainer originalPadding">
                                                <YouTube videoId="umWIvIe9144" opts={opts}/>
                                            </div>

                                            <h3 className="videoTitle w-100 text-center text-dark">
                                                Watch:{" "}
                                                <span className="videoTitleTreatment">
                                                  How can Living Well Center help you?
                                                </span>
                                            </h3>
                                        </div>
                                    </div>
                                    {/* End L31 Video Box Large */}`;
    language = 'jsx';
    const [state, copyToClipboard] = useCopyToClipboard();

    const copyCode = () => {
        // Logic to copy `code`
        copyToClipboard(code);
    };

    return (
        <CodeBlock code={code} language={language}>
            <div className="relative">
                <CodeBlock.Code className="bg-black">
                    <div className="table-row">
                        <CodeBlock.LineNumber className="table-cell pr-4 text-sm text-gray-500 text-right select-none" />
                        <CodeBlock.LineContent className="table-cell">
                            <CodeBlock.Token />
                        </CodeBlock.LineContent>
                    </div>
                </CodeBlock.Code>
                <div className="buttonContainer">
                    <button className="btn btn-primary ml-auto" onClick={copyCode}>
                        <i className="fa-solid fa-copy"></i> {state.value ? 'Copied!' :  'Copy code'}
                    </button>
                </div>
            </div>
        </CodeBlock>
    );
}

export default LegoL31Component;